import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';
import { ErrorFallback } from '@/components';

/** `errorElement` of the route tree: render errors of a page show here, inside the shell. */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  if (isRouteErrorResponse(error)) {
    return (
      <ErrorFallback
        error={new Error(`${error.status} ${error.statusText}`)}
        onRetry={() => void navigate(0)}
      />
    );
  }
  console.error(error);
  return <ErrorFallback error={error} />;
}
